<template>
  <a-modal
      v-model:visible="open"
      title="微信扫码登录"
      :footer="null"
      :width="360"
      centered
      :afterClose="() => { document.getElementById('login-qr-container').innerHTML = '' }"
  >
    <!-- 微信开放平台登录 -->
    <div class="qr-container" id="login-qr-container">
    </div>
  </a-modal>
</template>

<script>
import {defineComponent, onMounted, ref, nextTick} from 'vue'
import {message} from 'ant-design-vue'

export default defineComponent({
  name: 'PcWechatOpenPlatformLogin',
  props: {
    method: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const open = ref(false)

    // 提前加载微信登录JS文件
    const loadWxLoginScript = () => {
      return new Promise((resolve, reject) => {
        if (window.WxLogin) {
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = 'http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('加载微信登录组件失败'))
        document.body.appendChild(script)
      })
    }

    const wopLogin = async (method) => {
      // 微信开放平台登录
      try {
        // 确保微信登录JS已加载
        await loadWxLoginScript()
        open.value = true

        // 确保DOM已经更新
        nextTick(() => {
          new WxLogin({
            self_redirect: false,
            id: "login-qr-container",
            appid: method.options.appid,
            scope: "snsapi_login",
            redirect_uri: encodeURIComponent(method.options.redirect_uri),
            state: method.options.state || '',
            style: "black",
            href: ""
          })
        })
      } catch (error) {
        message.error(error.message || '微信登录初始化失败')
        console.error(error)
      }
    }

    onMounted(() => {
      wopLogin(props.method)
      // 加载时就预加载微信登录JS
      loadWxLoginScript().catch(error => {
        console.error('预加载微信登录JS失败:', error)
      })
    })

    return {
      open
    }
  }
})
</script>

<style scoped>

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
